<!-- Invoice print template -->
@if (invoiceDetail) {
  <div class="printable-screen invoice-page" #printTemplate>
    <div class="invoice-head">
      <div>
        <img src="/assets/images/logo.png" style="max-height: 50px;" alt="Logo" />
        @if (invoiceDetail.options.businessName) {
          <h2 class="business-name">{{ invoiceDetail.options.businessName }}</h2>
        }
        @if (invoiceDetail.options.businessAddress) {
          <p class="business-address">{{ invoiceDetail.options.businessAddress }}</p>
        }
        @if (invoiceDetail.options.vatRegNo || basketInvoice?.cardAcceptorTaxNumber) {
          <p class="vat-no">VAT Reg No: <b>{{ invoiceDetail.options.vatRegNo || basketInvoice?.cardAcceptorTaxNumber }}</b></p>
        }
      </div>
      <div class="invoice-title-block">
        <h1 class="invoice-title">INVOICE</h1>
        @if (invoiceDetail.options.invoiceNumber) {
          <p><span class="label">Invoice No:</span> {{ invoiceDetail.options.invoiceNumber }}</p>
        }
        @if (basketInvoice?.orderNumber) {
          <p><span class="label">Order No:</span> {{ basketInvoice?.orderNumber }}</p>
        }
        <p><span class="label">Date:</span> {{ (basketInvoice?.issueDate || invoiceDetail.receipt.time) | date: 'dd/MM/yyyy h:mm a' }}</p>
        @if (basketInvoice?.orderDate) {
          <p><span class="label">Order Date:</span> {{ $safeNavigationMigration(basketInvoice?.orderDate) | date: 'dd/MM/yyyy' }}</p>
        }
        @if (basketInvoice?.dueDate) {
          <p><span class="label">Due Date:</span> {{ $safeNavigationMigration(basketInvoice?.dueDate) | date: 'dd/MM/yyyy' }}</p>
        }
        <p><span class="label">Transaction Ref:</span> {{ invoiceDetail.receipt.traceId }}</p>
        @if (invoiceDetail.receipt.paymentReference) {
          <p><span class="label">Payment Ref:</span> {{ invoiceDetail.receipt.paymentReference }}</p>
        }
      </div>
    </div>

    <div class="bill-to">
      <h3>Billed To</h3>
      @if (invoiceDetail.options.billedTo || invoiceDetail.receipt.custName) {
        <p>{{ invoiceDetail.options.billedTo || invoiceDetail.receipt.custName }}</p>
      }
      @if (invoiceDetail.receipt.billingAddressLines.length) {
        @for (line of invoiceDetail.receipt.billingAddressLines; track $index) {
          <p>{{ line }}</p>
        }
      } @else if (invoiceDetail.receipt.custPostcode) {
        <p>{{ invoiceDetail.receipt.custPostcode }}</p>
      }
      @if (invoiceDetail.receipt.custEmail) {
        <p>{{ invoiceDetail.receipt.custEmail }}</p>
      }
      @if (basketInvoice?.customerTaxNumber) {
        <p>Tax Reg No: {{ basketInvoice?.customerTaxNumber }}</p>
      }
      @if (basketInvoice?.isTaxExempt) {
        <p>Tax Exempt</p>
      }
      @if (invoiceDetail.receipt.maskedCard) {
        <p>Card: {{ invoiceDetail.receipt.maskedCard }}</p>
      }
    </div>

    @if (invoiceDetail.receipt.deliveryAddressLines.length) {
      <div class="deliver-to">
        <h3>Deliver To</h3>
        @for (line of invoiceDetail.receipt.deliveryAddressLines; track $index) {
          <p>{{ line }}</p>
        }
      </div>
    }

    <table class="invoice-table">
      <thead>
        <tr>
          <th class="text-end">Qty</th>
          <th>Description</th>
          <th class="text-end">Unit price</th>
          <th class="text-end">Tax</th>
          <th class="text-end">Total</th>
        </tr>
      </thead>
      <tbody>
        @if (invoiceDetail.receipt.basketItems.length) {
          @for (item of invoiceDetail.receipt.basketItems; track item) {
            <tr>
              <td class="text-end">{{ item.quantity }}@if (item.unitOfMeasure) { <small> {{ item.unitOfMeasure }}</small> }</td>
              <td>
                {{ item.description }}
                @if (item.sku || item.commodityCode) {
                  <div class="line-meta">
                    @if (item.sku) { <span>SKU {{ item.sku }}</span> }
                    @if (item.commodityCode) { <span>Commodity {{ item.commodityCode }}</span> }
                  </div>
                }
                @if (item.discountAmount) {
                  <div class="line-meta">Includes discount of {{ item.discountAmount | currency: invoiceDetail.receipt.currencyCode }}</div>
                }
              </td>
              <td class="text-end">{{ item.unitPrice | currency: invoiceDetail.receipt.currencyCode }}</td>
              <td class="text-end">
                @if (item.taxAmount !== undefined && item.taxAmount !== null) {
                  {{ item.taxAmount | currency: invoiceDetail.receipt.currencyCode }}
                  <div class="line-meta">{{ invoiceDetail.receipt.taxLabel(item.taxCode, item.taxRate) }}</div>
                } @else { <span class="line-meta">&mdash;</span> }
              </td>
              <td class="text-end">{{ invoiceDetail.receipt.lineTotal(item) | currency: invoiceDetail.receipt.currencyCode }}</td>
            </tr>
          }
        } @else {
          <tr>
            <td class="text-end">1</td>
            <td>{{ invoiceDetail.receipt.detail || invoiceDetail.receipt.transactionType || 'Payment' }}</td>
            <td class="text-end">{{ invoiceDetail.receipt.amount | currency: invoiceDetail.receipt.currencyCode }}</td>
            <td class="text-end"><span class="line-meta">&mdash;</span></td>
            <td class="text-end">{{ invoiceDetail.receipt.amount | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        @if (invoiceDetail.receipt.basketItems.length) {
          <tr>
            <td colspan="4" class="text-end">Subtotal</td>
            <td class="text-end">{{ invoiceDetail.receipt.subtotal | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
        @for (discount of invoiceDetail.receipt.basketDiscounts; track discount) {
          <tr class="discount-row">
            <td colspan="4" class="text-end">
              Discount: {{ discount.description || discount.code }}
              @if (discount.rate) { <small>({{ discount.rate }}%)</small> }
              @if (discount.taxAmount !== undefined && discount.taxAmount !== null) {
                <small>includes {{ discount.taxAmount | currency: invoiceDetail.receipt.currencyCode }} {{ invoiceDetail.receipt.taxLabel(discount.taxCode, discount.taxRate) }}</small>
              }
            </td>
            <td class="text-end">-{{ discount.amount | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
        @if (invoiceDetail.receipt.delivery; as delivery) {
          <tr>
            <td colspan="4" class="text-end">
              Delivery: {{ delivery.carrier }}
              @if (delivery.taxAmount !== undefined && delivery.taxAmount !== null) {
                <small>(includes {{ delivery.taxAmount | currency: invoiceDetail.receipt.currencyCode }} {{ invoiceDetail.receipt.taxLabel(delivery.taxCode, delivery.taxRate) }})</small>
              }
            </td>
            <td class="text-end">{{ delivery.amount | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
        @for (tax of invoiceDetail.receipt.basketTaxes; track tax) {
          <tr>
            <td colspan="4" class="text-end">Tax: {{ tax.description || tax.code }} @if (tax.rate) { <small>({{ tax.rate }}%)</small> }</td>
            <td class="text-end">{{ tax.amount | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
        @if (invoiceDetail.receipt.hasTaxDetail) {
          <tr class="tax-total-row">
            <td colspan="4" class="text-end">Total tax <small>({{ invoiceDetail.receipt.taxTypeLabel | lowercase }})</small></td>
            <td class="text-end">{{ invoiceDetail.receipt.taxTotal | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
        @if (invoiceDetail.receipt.amountRefunded !== undefined && invoiceDetail.receipt.amountRefunded > 0) {
          <tr>
            <td colspan="4" class="text-end">Amount Refunded</td>
            <td class="text-end">-{{ invoiceDetail.receipt.amountRefunded | currency: invoiceDetail.receipt.currencyCode }}</td>
          </tr>
        }
        <tr class="total-row">
          <td colspan="4" class="text-end"><b>Total Paid</b></td>
          <td class="text-end"><b>{{ invoiceDetail.receipt.amount | currency: invoiceDetail.receipt.currencyCode }}</b></td>
        </tr>
      </tfoot>
    </table>
    @if (invoiceDetail.receipt.hasTaxDetail) {
      <p class="tax-summary">
        @for (line of invoiceDetail.receipt.taxSummary; track line.label; let last = $last) {
          <span>{{ line.label }}: {{ line.amount | currency: invoiceDetail.receipt.currencyCode }}</span>@if (!last) { <span> &middot; </span> }
        }
      </p>
    }

    <div class="invoice-meta">
      @if (invoiceDetail.receipt.status) {
        <p><span class="label">Status:</span> {{ invoiceDetail.receipt.status }}</p>
      }
      @if (invoiceDetail.receipt.authCode) {
        <p><span class="label">Authorisation Code:</span> {{ invoiceDetail.receipt.authCode }}</p>
      }
    </div>

    @if (invoiceDetail.options.notes) {
      <div class="invoice-notes">
        <h3>Notes</h3>
        <p>{{ invoiceDetail.options.notes }}</p>
      </div>
    }

    <p class="invoice-footer">Thank you for your business.</p>
  </div>
}
